require('./build/loading-bar');
module.exports = 'angular-loading-bar';



// WEBPACK FOOTER //
// ./node_modules/angular-loading-bar/index.js